<template>
  <div class="CancelReservations CommonContentSingle-gray">
    <el-dialog :title="$t('original.languages288')" :visible.sync="dialogTableVisible" width="520px" append-to-body @close="clearAddInformation()">
      <el-form ref="form" :model="form" label-width="80px">

        <el-form-item :label="$t('original.languages185')">
          {{ addInformation.RealName }}
        </el-form-item>

        <el-form-item label="限制类型" >
          <el-radio-group v-model="ctm" style="margin:0;">
            <el-radio label="1">个人</el-radio>
            <el-radio label="0">团体</el-radio>
          </el-radio-group>
        </el-form-item>

        


        <el-form-item v-if="ctm == '1'" label="限制对象">
          <el-select v-model="addInformation.UserID" filterable remote reserve-keyword :placeholder="$t('original.languages250')"  :remote-method="getVsitorNameList" :loading="loading" >
              <el-option v-for="item in VsitorNameList" :key="item.UserID" :label="item.RealName" :value="item.UserID" :disabled="item.Disabled == 'True' ? true : false" ></el-option>
            </el-select>
        </el-form-item>

        <el-form-item v-if="ctm == '0'" label="限制对象">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" :options="options" :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>

        <el-form-item label="限制方式:">
          <el-radio-group v-model="FullFlag" style="margin:0;">
            <el-radio label="1">所有咨询师</el-radio>
            <el-radio label="0">选中咨询师</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="FullFlag == '0'" label="咨询师">
          <el-select filterable v-model="addInformation.ConsultID" :placeholder="$t('original.languages250')" :loading="loading" >
            <el-option v-for="item in ConsultIDNameList" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="限制时间">
          <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                </el-date-picker>
        </el-form-item>



        <el-form-item :label="$t('original.languages251')">
          <el-input :placeholder="$t('original.languages327')" type="textarea" v-model="addInformation.Cause"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="dialogTableVisible = false">取消</el-button>
          <el-button type="primary" @click="AddApplyRelieve()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <el-container>
      <el-header style="background: rgba(255, 255, 255, 1);max-height: 206px;">
        <el-form ref="form" :model="form" style=" background: rgba(255, 255, 255, 1);overflow: hidden; height: 42px; ">
          <el-row style="height: 42px;">
            <div class="grid-content">
              <el-form-item :label="$t('original.account')">
                <el-input v-model="form.UserID" style="width: 280px;" :placeholder="$t('original.languages254')"></el-input>
                <el-button type="primary" style="margin-left: 20px" @click="getApplyRelieves()">{{ $t('original.screening') }}</el-button>
              </el-form-item>
            </div>
          </el-row>
        </el-form>
      </el-header>

      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1)">
        <el-button type="primary" @click="dialogTableVisible = true;getConsultIDNameList();" style="margin-bottom: 15px">{{ $t('original.languages288') }}</el-button>
        <el-table ref="multipleTable" v-loading="loading" :element-loading-text="$t('original.languages22')" element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%">

          <el-table-column :label="$t('original.The_serial_number')" min-width="6%" align="center">
            <template slot-scope="scope">
              {{ (Number(form.pageIndex) - 1) * 10 + Number(scope.$index) + 1 }}
            </template>
          </el-table-column>
          
          <el-table-column prop="UserID" :label="$t('original.account')" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="RealName" :label="$t('original.name')" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="ConsultName" :label="$t('original.languages225')" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="SourceType" :label="$t('original.languages328')" min-width="12%" align="center"></el-table-column>
          <el-table-column prop="CreatedTime" :label="$t('original.languages217')" min-width="10%" align="center"></el-table-column>
          <el-table-column :label="$t('original.languages49')" min-width="15%" align="center">
            <template slot-scope="scope">
              <span @click="dialoginfoVisible = true; SetAppointmentInfo(scope.row);" class="table_btn">
                {{ $t('original.languages329') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="form.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import add from "../Measurement/add.vue";
export default {
  components: { add },
  mounted() {
    this.getApplyRelieve(this.form);
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.options = res.Data;

      }
    })
  },
  data() {
    return {
      Counts:0,
      value1: '',
      options:[],
      DeptID:'',
      ctm:'1',
      FullFlag:'0',
      load: false,
      dialogTableVisible: false,//添加取消预约弹框
      addInformationShow: false,//控制添加申请附加信息显示
      dialoginfoVisible: false,
      loading: false,
      VsitorNameList: [],
      ConsultIDNameList: [],
      tableData: [], //列表表格数据
      DepartDrop: [],
      form: { entity: sessionStorage.getItem("entity"),CancelApproval:"",UserID:"",DepartID:"",pageSize: "10",pageIndex:1},
      addInformation: {
        RealName: JSON.parse(localStorage.getItem("userInfo")).UserName,
        UserID: "", //来访者姓名
        ConsultName: "",
        Cause: "",
      },
    };
  },
  methods: {
    getApplyRelieves() {
      this.form.pageIndex = 1
      this.getApplyRelieve(this.form)
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.getApplyRelieve(this.form);
    },
    Selected_to_shut_dow(dt) {
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.options[0];
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].DeptID == dt[dt.length - 1]) {
          obj = this.options[i]
          break
        } else if (this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.options[i].children,
          )
        }
      }
      let _this = this
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data
          }
        })
      }
    },
    getConsultIDNameList() {
      this.$Http_Post("ConsultSubscribe/GetAppointmentConsultIDNameList",{}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.ConsultIDNameList = res.Data;
        }
      });
    },

    getVsitorNameList(query) {
      if (query !== "") {
        this.$Http_Post("ConsultSubscribe/GetAppointmentNameList", {Query: query}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.VsitorNameList = res.Data;
          }
        });
      } else {
        this.VsitorNameList = [];
      }
    },
    SetAppointmentInfo(obj) {
      this.$confirm(this.$t('original.languages330'), this.$t('original.languages63'), {
        confirmButtonText: this.$t('original.languages59'),
        cancelButtonText: this.$t('original.cancel'),
        type: "warning",
      })
      .then(() => {
        this.$Http_Post("ConsultSubscribe/DeleteBlackList", {ConsultID: obj.ConsultID,UserID: obj.UserID,}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.$message({message: this.$t('original.languages167'),
              type: "success",
            });
            this.form.pageIndex = 1
            this.getApplyRelieve(this.form);
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t('original.languages160'),
        });
      });
    },
    AddApplyRelieve() {
        //申请解禁
        this.$Http_Post("ConsultSubscribe/AddBlackListMng", {UserID: this.addInformation.UserID,ConsultID: this.addInformation.ConsultID,Cause: this.addInformation.Cause, FullFlag : this.FullFlag, DeptID:this.DeptID, StartTime: this.value1[0],
        EndTime: this.value1[1], }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.$message({
              message: this.$t('original.languages306'),
              type: "success",
            });
            this.dialogTableVisible = false;
          } else {
            this.$message({message: res.Message,type: "warning",});
          }
          this.getApplyRelieve(this.form);
        });
      
    },
    ExportFile() {
      this.$Http_Post("ConsultSubscribe/ExportFile").then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loading = false;
        }
      });
    },
    getApplyRelieve(from) {
      this.loading = true;
      this.$Http_Post("ConsultSubscribe/GetBlackListMng", { from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Counts = res.Counts
          this.tableData = res.Data;
          this.loading = false;
        }
        }
      );
    },
    clearFrom() {this.form.CancelApproval = "";this.form.UserID = "";this.form.DepartID = "";},
    evocation(RelieveRecordID) {
      this.$Http_Post("ConsultSubscribe/UpdateApplyRelieve", {RelieveRecordID: RelieveRecordID,RelieveRecordState: 4,}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({message: this.$t('original.languages259'),type: "success",});
          this.dialogTableVisible = false;
          for (let index = 0; index < this.tableData.length; index++) {
            if (RelieveRecordID == this.tableData[index].RelieveRecordID) {
              this.tableData[index].RelieveRecordState = 4;
            }
          }
        }
      });
    },
  },
};
</script>

<style>
.CancelReservations .td_left {color: rgba(141, 141, 141, 1);font-size: 14px;padding: 15px;}
.CancelReservations .td_right {text-align: left;font-size: 14px;color: rgba(40, 40, 40, 1);}
.el-dialog {height: auto !important;}
.CancelReservations .buttons {width: 100%;text-align: center;margin: 20px;}
.CancelReservations .Statusblue {border-radius: 4px;padding: 5px 10px;background: rgba(29, 154, 255, 0.1);color: rgba(29, 154, 255, 1);}
.CancelReservations .Statusgreen {border-radius: 4px;background-color: rgba(21, 191, 109, 0.1);color: rgba(21, 191, 109, 1);padding: 5px 10px;}
.CancelReservations .Statusred {border-radius: 4px;background-color: rgba(242, 75, 78, 0.1);color: rgba(242, 75, 78, 1);padding: 5px 10px;}
.CancelReservations .Statusgray {border-radius: 4px;padding: 5px 10px;background: rgba(141, 141, 141, 0.1);color: rgba(141, 141, 141, 1);}
</style>


              